export default "__VITE_ASSET__92dd1bee__"